package pages.tab

import api.ActionMessage
import api.closeTab
import api.log
import components.*
import components.utils.orbit
import csstype.Display.Companion.block
import csstype.Display.Companion.none
import csstype.px
import kotlinext.js.jso
import locationBase
import react.CSSProperties
import react.FC
import react.css.css
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.hr
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import react.dom.svg.ReactSVG.path
import react.dom.svg.ReactSVG.svg
import react.router.useNavigate
import react.router.useParams
import react.useState


val tabEmpty = FC<TabEmptyProps> { props ->
	val history = useNavigate()
	val codeProps = useParams()
	val (closing, setClosing) = useState(false)
	val (modalShow, setShowModal) = useState(false)
	val (error, setError) = useState(false)
	divPage {
		if (modalShow) confirmModal {
			showIcon = true
			title = "Are you sure?"
			text = "No items have been added to your tab. Please confirm you would like to close your tab."
			booleanShowModal = modalShow
			this.cancelActionPressed = {
				it.preventDefault()
				setShowModal(false)

			}
			this.confirmActionPressed = {
				it.preventDefault()
				setClosing(true)
				setShowModal(false)
				setError(false)

				closeTab(codeProps["code"], 20 to "0.00", null, null, {
					setError(true)
					setClosing(false)
					api.error(ActionMessage("voiding_tab", "Tab voiding failed"))
				}, { history("${locationBase(codeProps)}/") }) {
					log(ActionMessage("voiding_tab", "Tab voided"))
					history("${locationBase(codeProps)}/voided")
				}
			}

		}
		location {
			showBack = false
		}
		div() {
			className = "section largest"
			div() {
				className = "container text-center"
				div() {
					className = "orbit-box small green"
					orbit()
					div() {
						className = "icon"
						svg() {
							className = "svg-icon"
							viewBox = "0 0 29.371 22.736"
							path {
								d = "M15.772,29.736,5.541,19.917,8.71,16.654l7.005,6.678L31.679,7l3.233,3.2Z"
								transform = "translate(-5.541 -7)"


								fill = "#ffffff"


							}
						}
					}
				}
				h1() {
					className = "text-green no-top-bottom"
					+"Your Tab is Open!"
				}
				p {
					className = "text-white float-middle"


					style=jso<CSSProperties>().apply {
						maxWidth = 280.px
					}
					+"Show the tab number below and order with your bartender or server:"
				}
				if (props.tabNumber != null) {
					p() {
						className = "huge text-white no-bottom"
						+props.tabNumber!!
					}
				} else {
					p() {
						className = "huge text-white no-bottom flashing"
						+"Loading"
					}
				}
			}
		}
		div {
			className = "section less no-bottom"


			css {
				display = if (error) block else none
			}
			container {
				div() {
					className = "message error"
					div() {
						className = "message-wrap"
						span() {
							className = "icon"
							svg() {
								className = "svg-icon"
								viewBox = "0 0 24 24"
								path {
									d =
										"M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-2h2V17z M13,13h-2V7h2V13z"



									fill = "#ec0b19"


								}
							}
						}
						p() {
							className="small text-white no-top-bottom"
							span() {
								className="font-weight-600"
								+"Issue Closing Tab."
							}
							+" Please try again."
						}
					}
				}
			}
		}
		div() {
			className="section no-top-bottom"
			div() {
				className="container text-center"
				hr {}
				div() {
					className="section less no-bottom"
					a{
						href = "${locationBase(codeProps)}/voided"
						className = "btn outline ${if (closing || modalShow) "disabled" else "white"}"

						onClick = {
							it.preventDefault()
							setShowModal(true)
						}
						+if (closing) "Closing Tab..." else "Close Tab"
					}
				}
			}
		}
		rooamFooter { }
	}
}
